/*! `julia-repl` grammar compiled for Highlight.js 11.3.1 */
var hljsGrammar=(()=>{"use strict";return a=>({name:"Julia REPL",contains:[{
className:"meta",begin:/^julia>/,relevance:10,starts:{end:/^(?![ ]{6})/,
subLanguage:"julia"},aliases:["jldoctest"]}]})})();export default hljsGrammar;